import React from "react";
import { defineMessages, useIntl } from "react-intl";
import Grid from "@mui/material/Grid";
import { makeStyles } from "tss-react/mui";
import { Card } from "../../components/card/Card.js";
import "../../components/chip/ChipRenderer.js";
import { ChipVariant, ChipType } from "../../components/chip/types.js";
import { Chip } from "../../components/chip/Chips.js";
import "../../components/chip/ListWithChipTooltip.js";
import "../../components/chip/SquaredChipList.js";
import "@mui/material";
import { Icon, IconColor } from "../../components/icons/Icon.js";
import { CustomIcon } from "../../components/icons/types.js";
import "../../components/icons/ExpandMoreIcon.js";
import "@mui/x-data-grid";
import "uuid";
import "../../components/alerts/InfoMessage.js";
import "../../components/alerts/NoAccessInfoMessage.js";
import "../../components/alerts/Message.style.js";
import { LocalizedText } from "../../components/i18n/LocalizedText.js";
import "../../components/alerts/InfoAlert.js";
import "../../components/alerts/InfoMessageHoc.js";
import "../../components/checkbox/StyledCheckbox.js";
import "fast-deep-equal/es6";
import "../../components/pagination/StyledPagination.js";
import "../../components/data-grid/mui/GridColumnsButton.js";
import "../../components/data-grid/mui/GridColumnsPanel.js";
import "../../components/data-grid/mui/hooks/useGridCellStyle.js";
import "../../components/data-grid/mui/hooks/useGridLocalization.js";
import "fast-deep-equal";
import "../../components/data-grid/mui/hooks/useGridStyle.js";
import "immer";
import "../../components/data-grid/mui/cells/InvalidDataCell.js";
import { CurrencyCell, Currency } from "../../components/data-grid/mui/cells/CurrencyCell.js";
import "../../components/data-grid/mui/cells/DateCell.js";
import { EmptyLabel } from "../../components/label/EmptyLabel.js";
import "../../components/label/LabelHoc.js";
import { StyledTooltip } from "../../components/tooltip/Tooltip.js";
import "moment-timezone";
import "../../components/tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../../components/tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../../components/tooltip/MultiLineAutoAdjustedWidthTooltip.js";
import "../../components/data-grid/mui/cells/LabelsCell.js";
import "../../components/data-grid/mui/cells/NumberCell.js";
import "../../components/data-grid/mui/cells/TextCell.js";
import "../../components/link/LinkHOC.js";
import "../../components/link/LinkButton.js";
import "../../components/data-grid/mui/cells/ActionWithConfirmationButton.js";
import "../../components/data-grid/mui/cells/TextListWithTooltipCell.js";
import { TextListCell } from "../../components/data-grid/mui/cells/TextListCell.js";
import { DurationCell } from "../../components/data-grid/mui/cells/DurationCell.js";
import { PercentCell } from "../../components/data-grid/mui/cells/PercentCell.js";
import "../../components/modal/BulkModalContent.js";
import "../../components/modal/BulkModalProvider.js";
import "../../components/modal/ModalButtons.js";
import "../../components/modal/Modal.style.js";
import "../../components/button/Buttons.js";
import "../../components/button/EditButton.js";
import "../../components/error/ErrorAccordion.js";
import "../../components/error/ErrorDetails.js";
import "../../components/error/localize.js";
import "../../components/error/ErrorModal.js";
import "../../components/error/GlobalServerErrorMessage.js";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "../../components/modal/types.js";
import "../../components/modal/ActionConfirmationModal.js";
import "../../components/data-grid/mui/cells/ButtonCell.js";
import { KeyValueCell } from "../../components/key-value-table/KeyValueCell.js";
import { KeyValueTable } from "../../components/key-value-table/KeyValueTable.js";
import { KeyValueColumn } from "../../components/key-value-table/KeyValueColumn.js";
import { CurrencyWithDateCell } from "../../components/key-value-table/cells/CurrencyWithDateCell.js";
import { TransactionType } from "../../contract/pam.js";
import { useLastTransaction } from "../transaction/hooks.js";
import "../../api/types.js";
import "@apollo/client/errors";
import "rxjs";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import { useUserActivitySummary } from "../user-activity-summary/hooks.js";
import "@automapper/core";
import "date-fns";
import "../user-profile/constants.js";
import { useUserProfileDetails } from "../user-profile/hooks.js";
import "typesafe-actions";
import { RealtimeUpdatesMode } from "../../redux-folder/realtime/types.js";
import "normalizr";
import "redux-observable";
import "../../redux-folder/async-action/action.js";
import "../../redux-folder/error-handling/action.js";
import "../../redux-folder/actions.js";
import "redux";
import "../../redux-folder/entity/epics.js";
import "../../redux-folder/entity/EntityProvider.js";
import "reselect";
import "react-redux";
import "react-router";
import "../../redux-folder/realtime/RealtimeNotification.js";
import "../user-profile/epics.js";
import "../user-profile/actions.js";
import "../user-profile/components/DataGrid.js";
import "../user-profile/components/Platform.js";
import "../../components/download/DownloadCsvButton.js";
import "../../components/download/DownloadTemplate.js";
import "../../auto-mapper/AutoMapperProvider.js";
import "../../components/filter/FilterGroupNew.js";
import "../../components/input/validation.js";
import "../../components/input/DatePicker.js";
import "../../components/input/DateRangePicker.js";
import "../../components/input/StyledInput.js";
import "../../components/input/FormInput.js";
import "../../components/input/StyledFormInputHoc.js";
import "../../components/input/DateSinglePicker.localize.js";
import "../../components/input/hooks.js";
import "../../components/filter/dateRangeFilter/DateRangeFilter.js";
import "../../components/filter/date-filter/DateFilter.js";
import "../../components/filter/TextFilterWithDropdown.js";
import "../../components/filter/MultiStepFilterDrawer.js";
import "../../components/filter/dateRangeFilter/MultiStepFilterDatePicker.js";
import "../../components/select/Select.js";
import "../../components/filter/TextFilter.js";
import "../../components/filter/valueRangeFilter/ValueRangeFilter.js";
import "../../components/filter/dateRangeFilter/localized.js";
import "../../components/filter/dateRangeFilter/DateRangeHistoricalFilter.js";
import "../../components/filter/MultiStepFilterApplyButton.js";
import "../../components/filter/MultiStepFilterInput.js";
import "../../components/filter/MultiStepFilterHoc.js";
import "../../components/select/selectStyle.js";
import "../../components/select/MultiSelectFooter.js";
import "../../components/select/MultiSelect.js";
import "../../components/select/MultiSelectItem.js";
import "../../components/select/SelectArrowIcon.js";
import "../../components/select/VirtualizedMultiSelectOptionList.js";
import "../../components/select/SingleSelect.js";
import "../../components/select/MultiSelectWithExclude.js";
import "../../components/select/MultiSelectTextCounterWithTooltip.js";
import "../../components/filter/PhoneFilter.js";
import "../brand-license/constants.js";
import "../country/components/CountryFilter.js";
import "../brand-license/components/BrandProvider.js";
import "react-oidc-context";
import "oidc-client-ts";
import "../brand-license/components/LicenseSelect.js";
import "../brand-license/components/BrandSelect.js";
import "../../components/circle-box/CircleBoxWithText.js";
import "@mui/material/colors";
import "@mui/material/locale";
import "@mui/material/styles";
import "../../style/hooks.js";
import "../../components/circle-box/CircleBox.js";
import "../user-profile/components/Filters.js";
import "../user-profile/components/P2PStatusCell.js";
import "../user-profile/components/UserDetailsWDBalance.js";
import "../user-profile/components/ReferralLinkButton.js";
import "../user-profile/components/PlayerIdAutocomplete.js";
const localized = defineMessages({
  title: {
    id: "PlayerFinancialSummary_title",
    defaultMessage: "Finance Info"
  },
  cashierTitle: {
    id: "PlayerFinancialSummary_cashierTitle",
    defaultMessage: "Cashier"
  },
  activityTitle: {
    id: "PlayerFinancialSummary_activityTitle",
    defaultMessage: "Activity"
  },
  valueTitle: {
    id: "PlayerFinancialSummary_valueTitle",
    defaultMessage: "Value"
  },
  bonusTitle: {
    id: "PlayerFinancialSummary_bonusTitle",
    defaultMessage: "Bonus"
  },
  // Cashier Card
  depositTotalTitle: {
    id: "PlayerFinancialSummary_depositTotalTitle",
    defaultMessage: "Total Deposit"
  },
  withdrawalTotalTitle: {
    id: "PlayerFinancialSummary_withdrawalTotalTitle",
    defaultMessage: "Total Withdrawal"
  },
  netDepositsTitle: {
    id: "PlayerFinancialSummary_netDepositsTitle",
    defaultMessage: "Net Deposits"
  },
  balanceTitle: {
    id: "PlayerFinancialSummary_balanceTitle",
    defaultMessage: "Current Balance"
  },
  withdrawableBalanceTitle: {
    id: "PlayerFinancialSummary_withdrawableBalanceTitle",
    defaultMessage: "Withdrawable Balance"
  },
  withdrawableBalanceTooltipFormula: {
    id: "PlayerFinancialSummary_withdrawableBalanceTooltipFormula",
    defaultMessage: "= Total Balance - Non-WD Balance"
  },
  withdrawableBalanceTooltipDescription: {
    id: "PlayerFinancialSummary_withdrawableBalanceTooltipDescription",
    defaultMessage: "Non-WD Balance unlocks with accumulated turnover."
  },
  withdrawableBalanceTooltipExample: {
    id: "PlayerFinancialSummary_withdrawableBalanceTooltipExample",
    defaultMessage: "Ex: 100% turnover → $100 turnover unlocks $100 from Non-WD Balance."
  },
  p2pCreditTotalTitle: {
    id: "PlayerFinancialSummary_p2pCreditTotalTitle",
    defaultMessage: "Total P2P Credit"
  },
  p2pDebitTotalTitle: {
    id: "PlayerFinancialSummary_p2pDebitTotalTitle",
    defaultMessage: "Total P2P Debit"
  },
  statusTitle: {
    id: "PlayerFinancialSummary_statusTitle",
    defaultMessage: "Status"
  },
  // Activity Card
  daysSinceLastActiveTitle: {
    id: "PlayerFinancialSummary_daysSinceLastActiveTitle",
    defaultMessage: "Days since last Active"
  },
  daysValue: {
    id: "PlayerFinancialSummary_daysValue",
    defaultMessage: "{days} days"
  },
  daysSinceRegistrationTitle: {
    id: "PlayerFinancialSummary_daysSinceRegistrationTitle",
    defaultMessage: "Days since Registration"
  },
  lastGameTitle: {
    id: "PlayerFinancialSummary_lastGameTitle",
    defaultMessage: "Last Game"
  },
  favCasinoGamesTitle: {
    id: "PlayerFinancialSummary_favCasinoGamesTitle",
    defaultMessage: "Fav Casino Games"
  },
  favSlotGamesTitle: {
    id: "PlayerFinancialSummary_favSlotGamesTitle",
    defaultMessage: "Fav Slot Games"
  },
  favPokerGamesTitle: {
    id: "PlayerFinancialSummary_favPokerGamesTitle",
    defaultMessage: "Fav Poker Games"
  },
  averageBetTitle: {
    id: "PlayerFinancialSummary_averageBetTitle",
    defaultMessage: "Average Bet"
  },
  averagePokerBuyInTitle: {
    id: "PlayerFinancialSummary_averagePokerBuyInTitle",
    defaultMessage: "Average Poker Buy-in"
  },
  // Value Card
  lifetimeGGRTitle: {
    id: "PlayerFinancialSummary_lifetimeGGRTitle",
    defaultMessage: "Lifetime GGR"
  },
  casinoGGRTitle: {
    id: "PlayerFinancialSummary_casinoGGRTitle",
    defaultMessage: "Casino GGR"
  },
  pokerGGRTitle: {
    id: "PlayerFinancialSummary_pokerGGRTitle",
    defaultMessage: "Poker GGR"
  },
  sportsGGRTitle: {
    id: "PlayerFinancialSummary_sportsGGRTitle",
    defaultMessage: "Sportsbook GGR"
  },
  casinoCoinBalanceTitle: {
    id: "PlayerFinancialSummary_casinoCoinBalanceTitle",
    defaultMessage: "Casino Coin Balance"
  },
  vipTitle: {
    id: "PlayerFinancialSummary_vipTitle",
    defaultMessage: "VIP"
  },
  // Bonus Card
  bonusTotalTitle: {
    id: "PlayerFinancialSummary_bonusTotalTitle",
    defaultMessage: "Total Bonus"
  },
  bonusRatioTitle: {
    id: "PlayerFinancialSummary_bonusRatioTitle",
    defaultMessage: "Bonus Ratio"
  },
  bonusToDepositTitle: {
    id: "PlayerFinancialSummary_bonusToDepositTitle",
    defaultMessage: "Bonus to Deposit"
  },
  eligibleForBonusTitle: {
    id: "PlayerFinancialSummary_eligibleForBonusTitle",
    defaultMessage: "Eligible for Bonus"
  },
  yesValue: {
    id: "PlayerFinancialSummary_yesValue",
    defaultMessage: "Yes"
  },
  noValue: {
    id: "PlayerFinancialSummary_noValue",
    defaultMessage: "No"
  },
  maxTitle: {
    id: "PlayerFinancialSummary_maxTitle",
    defaultMessage: "Max"
  },
  lastBonusTitle: {
    id: "PlayerFinancialSummary_lastBonusTitle",
    defaultMessage: "Last Bonus Awarded"
  },
  lastDepositTitle: {
    id: "PlayerFinancialSummary_lastDepositTitle",
    defaultMessage: "Last Deposit"
  },
  winningPlayer: {
    id: "PlayerFinancialSummary_winningPlayer",
    defaultMessage: "Winning Player"
  },
  losingPlayer: {
    id: "PlayerFinancialSummary_losingPlayer",
    defaultMessage: "Losing Player"
  }
});
const useStyles = makeStyles()((theme) => ({
  financialInfoContainer: {
    padding: theme.spacing(0, 4)
  },
  financialInfoCard: {
    border: `1px solid ${theme.custom.palette.content.border}`,
    borderRadius: theme.custom.defaultBorderRadius * 3,
    width: "100%",
    height: "100%"
  },
  financialInfoCardTitle: {
    marginBottom: theme.spacing()
  },
  financialInfoCellWithTooltip: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1),
    alignItems: "center"
  }
}));
function PlayerFinancialSummary({
  userId,
  currency,
  userActivitySummaryEntity,
  transactionEntity,
  withRealtime,
  cells
}) {
  const viewType = "FinanceInfo";
  const { classes } = useStyles();
  const { formatMessage } = useIntl();
  const keys = [
    "uid",
    cells.some((f) => ["depositTotal", "netDeposits", "status", "bonusToDeposit"].includes(f)) ? "deposit_total" : null,
    cells.some((f) => ["withdrawalTotal", "netDeposits", "status"].includes(f)) ? "withdrawal_approved_amount" : null,
    cells.some((f) => ["balance", "status"].includes(f)) ? "balance" : null,
    cells.includes("casinoCoinBalance") ? "finance.casino_coin_balance" : null,
    cells.some((f) => ["p2pCreditTotal", "status"].includes(f)) ? "finance.p2p_credit.successful_amount" : null,
    cells.some((f) => ["p2pDebitTotal", "status"].includes(f)) ? "finance.p2p_debit.successful_amount" : null,
    cells.includes("withdrawableBalance") ? "finance.withdrawable_balance" : null,
    cells.includes("daysSinceRegistration") ? "date_of_joining.seconds" : null,
    cells.some((f) => ["lifetimeGGR", "bonusRatio", "bonusToDeposit", "eligibleForBonus", "max", "casinoGGR"].includes(f)) ? "casino_ggr_lifetime" : null,
    cells.some((f) => ["lifetimeGGR", "bonusRatio", "bonusToDeposit", "eligibleForBonus", "max", "pokerGGR"].includes(f)) ? "poker_ggr_lifetime" : null,
    cells.some((f) => ["lifetimeGGR", "bonusRatio", "bonusToDeposit", "eligibleForBonus", "max", "sportsGGR"].includes(f)) ? "sports_ggr_lifetime" : null,
    cells.some((f) => ["bonusTotal", "bonusRatio", "bonusToDeposit", "eligibleForBonus", "max"].includes(f)) ? "lifetime_bonus" : null
  ];
  const { item } = useUserProfileDetails({
    id: userId,
    fields: keys.filter(Boolean),
    viewType,
    realtimeMode: withRealtime && RealtimeUpdatesMode.Confirm,
    displayName: localized.title
  });
  const activityKeys = [
    cells.includes("averageBet") ? "average_bet" : null,
    cells.includes("averagePokerBuyIn") ? "average_poker_buy_in" : null,
    cells.includes("favCasinoGames") ? "casino_favorite_games" : null,
    cells.includes("daysSinceLastActive") ? "days_from_last_active" : null,
    cells.includes("lastGame") ? "last_played_game" : null,
    cells.includes("favPokerGames") ? "poker_favorite_games" : null,
    cells.includes("vip") ? "skill_flag" : null,
    cells.includes("favSlotGames") ? "slot_favorite_games" : null
  ].filter(Boolean);
  const { item: userActivity } = useUserActivitySummary({
    id: userId,
    fields: activityKeys,
    viewType,
    displayName: localized.title,
    userActivitySummaryEntity
  });
  const currentBalance = item?.finance?.balance;
  const depositTotal = item?.finance?.deposit?.total?.successful_amount;
  const withdrawalTotal = item?.finance?.withdrawal?.total?.successful_amount;
  const p2pDebitTotal = item?.finance?.p2p_debit?.successful_amount;
  const p2pCreditTotal = item?.finance?.p2p_credit?.successful_amount;
  const lifetimeBonus = item?.finance?.lifetime_bonus;
  const ggr = item?.finance?.ggr_lifetime?.casino + item?.finance?.ggr_lifetime?.poker + item?.finance?.ggr_lifetime?.sports;
  const bonusRatio = lifetimeBonus && ggr ? lifetimeBonus / ggr : null;
  return /* @__PURE__ */ React.createElement(Grid, { container: true, spacing: 1.5, columns: 16, className: classes.financialInfoContainer }, /* @__PURE__ */ React.createElement(FinancialInfoCard, { title: localized.cashierTitle }, cells.includes("depositTotal") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.depositTotalTitle), mode: "card" }, /* @__PURE__ */ React.createElement(CurrencyCell, { value: depositTotal, currency })) : null, cells.includes("withdrawalTotal") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.withdrawalTotalTitle), mode: "card" }, /* @__PURE__ */ React.createElement(CurrencyCell, { value: withdrawalTotal, currency })) : null, cells.includes("lastDeposit") ? /* @__PURE__ */ React.createElement(LastDepositCell, { uid: userId, mode: "card", transactionEntityType: transactionEntity }) : null, cells.includes("netDeposits") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.netDepositsTitle), mode: "card" }, /* @__PURE__ */ React.createElement(CurrencyCell, { value: (depositTotal ?? 0) - (withdrawalTotal ?? 0), currency, isNet: true })) : null, cells.includes("balance") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.balanceTitle), mode: "card" }, /* @__PURE__ */ React.createElement(CurrencyCell, { value: currentBalance, currency })) : null, cells.includes("withdrawableBalance") ? /* @__PURE__ */ React.createElement(
    KeyValueCell,
    {
      title: /* @__PURE__ */ React.createElement(
        StyledTooltip,
        {
          title: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(LocalizedText, { label: localized.withdrawableBalanceTooltipFormula })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(LocalizedText, { label: localized.withdrawableBalanceTooltipDescription })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(LocalizedText, { label: localized.withdrawableBalanceTooltipExample }))),
          element: /* @__PURE__ */ React.createElement("div", { className: classes.financialInfoCellWithTooltip }, /* @__PURE__ */ React.createElement(LocalizedText, { label: localized.withdrawableBalanceTitle }), /* @__PURE__ */ React.createElement(Icon, { color: IconColor.Secondary, icon: CustomIcon.ErrorCircleOutline }))
        }
      ),
      mode: "card"
    },
    /* @__PURE__ */ React.createElement(CurrencyCell, { value: item?.finance?.withdrawable_balance, currency })
  ) : null, cells.includes("p2pDebitTotal") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.p2pDebitTotalTitle), mode: "card" }, /* @__PURE__ */ React.createElement(CurrencyCell, { value: p2pDebitTotal, currency })) : null, cells.includes("p2pCreditTotal") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.p2pCreditTotalTitle), mode: "card" }, /* @__PURE__ */ React.createElement(CurrencyCell, { value: p2pCreditTotal, currency })) : null, cells.includes("status") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.statusTitle), mode: "card" }, /* @__PURE__ */ React.createElement(
    PlayerStatusCellValue,
    {
      currentBalance,
      depositTotal,
      withdrawalTotal,
      p2pDebitTotal,
      p2pCreditTotal
    }
  )) : null), /* @__PURE__ */ React.createElement(FinancialInfoCard, { title: localized.activityTitle }, cells.includes("daysSinceLastActive") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.daysSinceLastActiveTitle), mode: "card" }, /* @__PURE__ */ React.createElement(DurationCell, { count: userActivity?.days_from_last_active, mode: "days" })) : null, cells.includes("daysSinceRegistration") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.daysSinceRegistrationTitle), mode: "card" }, /* @__PURE__ */ React.createElement(DurationCell, { timestamp: item?.date_of_joining, mode: "days" })) : null, cells.includes("lastGame") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.lastGameTitle), mode: "card" }, /* @__PURE__ */ React.createElement(TextListCell, { list: userActivity?.last_played_game ? [userActivity?.last_played_game] : [] })) : null, cells.includes("favCasinoGames") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.favCasinoGamesTitle), mode: "card" }, /* @__PURE__ */ React.createElement(TextListCell, { list: userActivity?.casino_favorite_games })) : null, cells.includes("favSlotGames") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.favSlotGamesTitle), mode: "card" }, /* @__PURE__ */ React.createElement(TextListCell, { list: userActivity?.slot_favorite_games })) : null, cells.includes("favPokerGames") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.favPokerGamesTitle), mode: "card" }, /* @__PURE__ */ React.createElement(TextListCell, { list: userActivity?.poker_favorite_games })) : null, cells.includes("averageBet") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.averageBetTitle), mode: "card" }, /* @__PURE__ */ React.createElement(CurrencyCell, { value: userActivity?.average_bet, currency })) : null, cells.includes("averagePokerBuyIn") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.averagePokerBuyInTitle), mode: "card" }, /* @__PURE__ */ React.createElement(CurrencyCell, { value: userActivity?.average_poker_buy_in, currency })) : null), /* @__PURE__ */ React.createElement(FinancialInfoCard, { title: localized.valueTitle }, cells.includes("lifetimeGGR") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.lifetimeGGRTitle), mode: "card" }, /* @__PURE__ */ React.createElement(CurrencyCell, { value: ggr, currency })) : null, cells.includes("pokerGGR") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.pokerGGRTitle), mode: "card" }, /* @__PURE__ */ React.createElement(CurrencyCell, { value: item?.finance?.ggr_lifetime?.poker, currency })) : null, cells.includes("casinoGGR") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.casinoGGRTitle), mode: "card" }, /* @__PURE__ */ React.createElement(CurrencyCell, { value: item?.finance?.ggr_lifetime?.casino, currency })) : null, cells.includes("sportsGGR") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.sportsGGRTitle), mode: "card" }, /* @__PURE__ */ React.createElement(CurrencyCell, { value: item?.finance?.ggr_lifetime?.sports, currency })) : null, cells.includes("casinoCoinBalance") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.casinoCoinBalanceTitle), mode: "card" }, /* @__PURE__ */ React.createElement(CurrencyCell, { value: item?.finance?.casino_coin_balance, currency: Currency.CasinoCoin })) : null, cells.includes("vip") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.vipTitle), mode: "card" }, /* @__PURE__ */ React.createElement(LocalizedText, { label: userActivity?.skill_flag ? localized.yesValue : localized.noValue })) : null), /* @__PURE__ */ React.createElement(FinancialInfoCard, { title: localized.bonusTitle }, cells.includes("bonusTotal") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.bonusTotalTitle), mode: "card" }, /* @__PURE__ */ React.createElement(CurrencyCell, { value: lifetimeBonus, currency })) : null, cells.includes("bonusRatio") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.bonusRatioTitle), mode: "card" }, /* @__PURE__ */ React.createElement(PercentCell, { value: bonusRatio })) : null, cells.includes("bonusToDeposit") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.bonusToDepositTitle), mode: "card" }, /* @__PURE__ */ React.createElement(PercentCell, { value: lifetimeBonus && ggr ? lifetimeBonus / depositTotal : null })) : null, cells.includes("lastBonus") ? /* @__PURE__ */ React.createElement(LastBonusCell, { uid: userId, mode: "card", transactionEntityType: transactionEntity }) : null, cells.includes("eligibleForBonus") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.eligibleForBonusTitle), mode: "card" }, /* @__PURE__ */ React.createElement(LocalizedText, { label: bonusRatio > 25 ? localized.yesValue : localized.noValue })) : null, cells.includes("max") ? /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.maxTitle), mode: "card" }, /* @__PURE__ */ React.createElement(CurrencyCell, { value: (25 - bonusRatio) / 500, currency })) : null));
}
function FinancialInfoCard({ title, children }) {
  const { classes } = useStyles();
  return /* @__PURE__ */ React.createElement(Grid, { size: { xs: 8 } }, /* @__PURE__ */ React.createElement(
    Card,
    {
      title,
      variant: "h4",
      className: classes.financialInfoCard,
      titleClassName: classes.financialInfoCardTitle,
      styledContent: false
    },
    /* @__PURE__ */ React.createElement(KeyValueTable, { mode: "card" }, /* @__PURE__ */ React.createElement(KeyValueColumn, null, children))
  ));
}
function LastBonusCell({ uid, mode, transactionEntityType }) {
  const { formatMessage } = useIntl();
  const viewType = "LastBonus";
  const transaction = useLastTransaction({
    uid,
    viewType,
    types: [TransactionType.Bonus],
    transactionEntityType
  });
  const value = transaction ? { amount: transaction.amount, currency: transaction.currency, date: transaction.transaction_started_ts } : null;
  return /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.lastBonusTitle), mode }, /* @__PURE__ */ React.createElement(CurrencyWithDateCell, { value }));
}
function LastDepositCell({ uid, mode, transactionEntityType }) {
  const { formatMessage } = useIntl();
  const viewType = "LastDeposit";
  const transaction = useLastTransaction({
    uid,
    viewType,
    types: [TransactionType.Deposit, TransactionType.Payin],
    transactionEntityType
  });
  const value = transaction ? { amount: transaction.amount, currency: transaction.currency, date: transaction.transaction_started_ts } : null;
  return /* @__PURE__ */ React.createElement(KeyValueCell, { title: formatMessage(localized.lastDepositTitle), mode }, /* @__PURE__ */ React.createElement(CurrencyWithDateCell, { value }));
}
function PlayerStatusCellValue({ currentBalance, depositTotal, withdrawalTotal, p2pDebitTotal, p2pCreditTotal }) {
  const { formatMessage } = useIntl();
  let result = /* @__PURE__ */ React.createElement(EmptyLabel, { defaultSymbol: "dash" });
  const income = (currentBalance ?? 0) + (withdrawalTotal ?? 0) + (p2pDebitTotal ?? 0);
  const expense = (depositTotal ?? 0) + (p2pCreditTotal ?? 0);
  if (income > expense) {
    result = /* @__PURE__ */ React.createElement(
      Chip,
      {
        fillWidth: false,
        chipType: ChipType.Status,
        chipVariant: ChipVariant.Green,
        label: formatMessage(localized.winningPlayer)
      }
    );
  } else if (income < expense) {
    result = /* @__PURE__ */ React.createElement(
      Chip,
      {
        fillWidth: false,
        chipType: ChipType.Status,
        chipVariant: ChipVariant.Purple,
        label: formatMessage(localized.losingPlayer)
      }
    );
  }
  return result;
}
export {
  PlayerFinancialSummary
};
//# sourceMappingURL=PlayerFinancialSummary.js.map
